import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Sparkles } from "@react-three/drei";
import * as THREE from "three";

const Monolith = ({ mouse }) => {
  const grp = useRef();
  useFrame((state, d) => {
    const g = grp.current;
    if (!g) return;
    g.rotation.y += d * 0.12;
    const mx = mouse ? mouse.current.x : 0;
    const my = mouse ? mouse.current.y : 0;
    g.rotation.x = THREE.MathUtils.lerp(g.rotation.x, my * 0.25, 0.05);
    g.position.x = THREE.MathUtils.lerp(g.position.x, mx * 0.3, 0.05);
  });

  return (
    <group ref={grp}>
      {/* Obsidian faceted core */}
      <mesh>
        <icosahedronGeometry args={[1.7, 0]} />
        <meshStandardMaterial color="#0a0a0a" metalness={1} roughness={0.15} flatShading />
      </mesh>
      {/* Bronze wireframe veil */}
      <mesh scale={1.02}>
        <icosahedronGeometry args={[1.7, 0]} />
        <meshBasicMaterial color="#C5A059" wireframe transparent opacity={0.4} />
      </mesh>
      {/* Orbiting bronze rings — the gate */}
      <mesh rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[2.7, 0.01, 16, 160]} />
        <meshBasicMaterial color="#C5A059" transparent opacity={0.55} />
      </mesh>
      <mesh rotation={[Math.PI / 2.2, 0.6, 0]}>
        <torusGeometry args={[3.1, 0.006, 16, 160]} />
        <meshBasicMaterial color="#C5A059" transparent opacity={0.3} />
      </mesh>
    </group>
  );
};

export const ObsidianGate = ({ mouse }) => (
  <>
    <ambientLight intensity={0.35} />
    <pointLight position={[5, 5, 5]} intensity={55} color="#C5A059" />
    <pointLight position={[-5, -3, -3]} intensity={25} color="#3B2A48" />
    <Monolith mouse={mouse} />
    <Sparkles count={120} scale={12} size={2} speed={0.2} color="#C5A059" opacity={0.45} />
  </>
);

export default ObsidianGate;
